import { initialState } from "./salaryCalculationTaxFigures";

//add inputs here, import totalyeargross and fixed cost here
const SalaryCalculationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SURPLUS_BEFORE_TAX":
      return { ...state, surplus: action.payload };
    case "GET_TEMPLATE_PAYROLL_TAX":
      return { ...state, templatePayroll: action.payload };
    case "GET_TEMPLATE_PAYROLL_PERCENT":
      return { ...state, templatePayrollPercent: action.payload };
    case "GET_FIXED_EARNED_INCOME":
      return { ...state, fixedEarnedIncome: action.payload };
    case "GET_STANDARD_TAX_RELIEF":
      return { ...state, standardTaxRelief: action.payload };
    case "GET_TAXABLE_INCOME":
      return { ...state, taxableIncome: action.payload };
    case "GET_LOCAL_TAXES":
      return { ...state, localTaxes: action.payload };
    case "GET_LOCAL_TAXES_PERCENT":
      return { ...state, localTaxesPercent: action.payload };
    case "GET_STATE_TAX":
      return { ...state, stateTax: action.payload };
    case "GET_STATE_TAX_CUT_OF_VALUE":
      return { ...state, stateTaxCutOfValue: action.payload };
    case "GET_STATE_TAX_PERCENT":
      return { ...state, stateTaxPercent: action.payload };
    case "GET_PAYROLL_TAX":
      return { ...state, payrollTax: action.payload };
    case "GET_PAYROLL_TAX_PERCENT":
      return { ...state, payrollTaxPercent: action.payload };
    case "GET_GENERAL_PENSION":
      return { ...state, generalPension: action.payload };
    case "GET_GENERAL_PENSION_CUT_OFF_VALUE":
      return { ...state, generalPensionCutOffValue: action.payload };
    case "GET_GENERAL_PENSION_PERCENT":
      return { ...state, generalPensionPercent: action.payload };
    case "GET_FUNERAL_FEES":
      return { ...state, funeralFees: action.payload };
    case "GET_FUNERAL_FEES_PERCENT":
      return { ...state, funeralFeesPercent: action.payload };
    case "GET_REDUCTION_OF_GENERAL_PENSION":
      return { ...state, reductionOfGeneralPension: action.payload };
    case "GET_EARNED_INCOME_TAX":
      return { ...state, earnedIncomeTax: action.payload };
    case "GET_EARNED_INCOME_TAX_CUT_OFF_VALUE":
      return { ...state, earnedIncomeTaxCutOffValue: action.payload };
    case "GET_EARNED_INCOME_TAX_PERCENT":
      return { ...state, earnedIncomeTaxPercent: action.payload };
    case "GET_NET_PROFIT_PER_YEAR":
      return { ...state, netProfitPerYear: action.payload };
    case "GET_NET_PROFIT_PER_MONTH":
      return { ...state, netProfitPerMonth: action.payload };
    case "GET_GENERAL_PAYROLL_TAX":
      return { ...state, generalPayrollTax: action.payload };
    case "GET_GENERAL_PAYROLL_TAX_PERCENT":
      return { ...state, generalPayrollTaxPercent: action.payload };
    case "GET_GROSS_ANNUAL_SALARY":
      return { ...state, grossAnnualSalary: action.payload };
    case "GET_NON_TAXABLE_INCOME_LIMIT":
      return { ...state, nonTaxableIncomeLimit: action.payload };
    default:
      return state;
  }
};

export default SalaryCalculationReducer;
